import {
  USER_MOBILE,
  VERIFY_CODE,
  AUTH_STEP,
  PLATFORM
} from "../Actions/AuthAction";

const initialState = {
  userMobile:"",
  verifyCode: "",
  authTab:0,
  platform:""
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_MOBILE:
      return { ...state, userMobile:action.payload };
    case VERIFY_CODE:
      return { ...state, verifyCode: action.payload };
    case AUTH_STEP:
      return {...state , authTab:action.payload};
    case PLATFORM:
      return {...state , platform:action.payload};
    default:
      return state;
  }
};
export default AuthReducer;
